import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { AgreementRequestDto, AgreementsDto } from '../../modules/user-agreements/agreement';
export const AgreementAction = createActionGroup({
	source: 'Agreement',
	events: {
		loaderStart: emptyProps(),
		loaderEnd: emptyProps(),
		load: props<{ hardReload: boolean }>(),
		set: props<{ agreements: AgreementsDto[] }>(),
		agreementStatusUpdated: props<{ agreementDto: AgreementRequestDto }>(),
		updateAgreementStatus: props<{ agreementDto: AgreementRequestDto }>()
	}
});
